module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/POI-window-closed.svg?4bf4a5a0623d7b0f7c1e651c1b64d41b";